import {FC, useEffect, useState} from "react";
import Checkers from "../../../../helpers/class/Checkers";
import SwipperWrapper from "./SwipperWrapper";
import SimpleContent from "./SImpleContent";
import * as React from "react";
import AttributesList from "./AttributesList";
import FeaturesList from "./FeaturesList";
import BedsArrangement from "./BedsArrangement";
import {fetchPropertyBedroomById, fetchPropertyBedrooms} from "../../../../redux/actions";
import {useDispatch, useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";

interface BedroomsContentWrapperProps {
    data: any
}
const BedroomsContentWrapper: FC<BedroomsContentWrapperProps> = ({data} ) => {

    const propertyId = useSelector( state => Checkers.isValidPositiveNumber(state['propertiesParams']['property_id']) ?
        state['propertiesParams']['property_id']
        : (state['propertiesParams']['property_id']).substring(0, (state['propertiesParams']['property_id']).indexOf("?"))
    );

    const pageId = useSelector(state => state['propertiesParams']['page_id']);

    const dispatch = useDispatch()

    const [selectedBedroomId, setSelectedBedroomId] = useState( data.bedroom_id )

    useEffect( () => {
        dispatch<any>(fetchPropertyBedroomById(pageId, propertyId, selectedBedroomId))
    }, [])

    const fetchBedroomData = (bedroomId) => {
        setSelectedBedroomId(bedroomId)
        dispatch<any>(fetchPropertyBedroomById(pageId, propertyId, bedroomId))
    }

    const propertyBedroom = useSelector( state => state['singlePropertyData']['modalSingleBedroom'])

    const propertyBedroomData = propertyBedroom.hasOwnProperty('data') ? (Checkers.isValidArray(propertyBedroom.data) ? propertyBedroom.data[0] : (propertyBedroom.hasOwnProperty('data') ? propertyBedroom.data : null)) : null

    return (
        <>
            <div className="row w-100 no-margin">
                <div className="col-md-12 no-padding">
                    <div className="panel panel-transparent m-b-0">
                        <>
                        {
                            data.length>1 ?
                                <>
                                    <div className="nav-tabs-header nav-tabs-linetriangle">
                                        <ul className="nav nav-tabs nav-tabs-linetriangle"
                                            role="tablist"
                                            style={{width: "auto", whiteSpace: "nowrap", display: "inline-block"}}
                                            data-init-reponsive-tabs="dropdownfx">
                                            {
                                                Checkers.isValidArray(data) && data.map((bedroom, i) => {
                                                    return (
                                                        <>
                                                            <li>
                                                                <a className={"fs-12 " + (i == 0 ? "active" : "")}
                                                                   data-toggle="tab"
                                                                   href={"#slide" + bedroom.bedroom_id}
                                                                   data-bs-toggle="tab"
                                                                   onClick={() => fetchBedroomData(bedroom.bedroom_id)}
                                                                   data-bs-target={"#slide" + bedroom.bedroom_id}>
                                                                    <span>{bedroom.bedroom_title}</span>
                                                                </a>
                                                            </li>
                                                        </>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </>
                                : <></>
                        }
                        </>
                        <div className="tab-content">
                            {
                                <>
                                    {
                                        propertyBedroom.valid ?
                                            <>
                                                {
                                                    propertyBedroomData != null ?
                                                        <>
                                                            {
                                                                propertyBedroomData.hasOwnProperty('media') && Checkers.isValidArray(propertyBedroomData.media) ?
                                                                    <SwipperWrapper key="bedroom-image-swiper"
                                                                                    images={propertyBedroomData.media}
                                                                                    enableFancyBox={true}
                                                                                    enableAlbumRightModal={false}/>
                                                                    :
                                                                    <></>
                                                            }
                                                            <SimpleContent content={propertyBedroomData.description}/>
                                                            <AttributesList data={propertyBedroomData}/>
                                                            <BedsArrangement data={propertyBedroomData} />
                                                                        <FeaturesList featureList={propertyBedroomData.features}/>
                                                                    </>
                                                                    :
                                                                    <>
                                                                    </>
                                                            }
                                                        
                                                    </>
                                                    :
                                                    <>
                                                        <div>
                                                            <Skeleton height={340} className="col-12 b-rad-lg d-block"/>
                                                            <Skeleton height={27} className="col-12 b-rad-lg d-block"/>
                                                            <Skeleton height={27} className="col-12 b-rad-lg d-block"/>
                                                        </div>
                                                    </>
                                            }
                                        </>
                               
                            }
                        </div>
                    </div>
                </div>
            </div>
            {/*{*/}
            {/*    data.map( (bedroom) => {*/}
            {/*        return (*/}
            {/*            <>*/}
            {/*                <SwipperWrapper images={bedroom.media} />*/}
            {/*                <SimpleContent content={bedroom.description} />*/}
            {/*                <AttributesList data={bedroom} />*/}
            {/*                <FeaturesList featureList={bedroom.features}/>*/}
            {/*            </>*/}
            {/*        )*/}
            {/*    })*/}
            {/*}*/}
            {/*{*/}
            {/*        <>*/}
            {/*            <div className="row w-100 no-margin">*/}
            {/*                <div className="col-md-12 no-padding">*/}
            {/*                    <div className="panel panel-transparent m-b-0">*/}
            {/*                        <ul className="nav nav-tabs nav-tabs-simple" role="tablist" data-init-reponsive-tabs="dropdownfx">*/}
            {/*                            <li>*/}
            {/*                                <a  className="active" data-toggle="tab" href="#slide1" data-bs-toggle="tab" data-bs-target={'#slide1'}>*/}
            {/*                                    <span>Home</span>*/}
            {/*                                </a>*/}
            {/*                            </li>*/}
            {/*                            <li>*/}
            {/*                                <a data-toggle="tab" href="#slide2" data-bs-toggle="tab" data-bs-target={'#slide2'}>*/}
            {/*                                    <span>Profile</span>*/}
            {/*                                </a>*/}
            {/*                            </li>*/}
            {/*                        </ul>*/}
            {/*                        <div className="tab-content">*/}
            {/*                            <div className="tab-pane fade show active" id="slide1">*/}
            {/*                                tab 1*/}
            {/*                            </div>*/}
            {/*                            <div className="tab-pane fade" id="slide2">*/}
            {/*                                tab 2*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </>*/}
            {/*}*/}
        </>
    )
}

export default BedroomsContentWrapper